var _excluded = ["data", "columns", "meta", "captionId", "onRowClick", "isLoading", "hideHeaderWhileLoading", "loadingRowIds", "disableAllRowsSelection", "disableRowSelection", "rowSelectionTooltips", "defaultSelectedRows", "mobileRowRenderer", "isHeaderSticky", "selectedRows", "setSelectedRows", "onRowSelectionChange", "onAllRowsSelectionChange", "getRowSelectionAriaLabel", "allRowsSelectionAriaLabel", "defaultExpandedRows", "onRowExpandChange", "highlightedRowIds", "headerVariant", "sortingState", "setSortState", "getRowAriaLabel", "skipToLink"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { getCoreRowModel, getExpandedRowModel, useReactTable } from '@tanstack/react-table';
import React from 'react';
import { toPennySortingState, toReactTableOnSortingChange, toReactTableSortingState } from '../components/Table/tableSorting.utils';
import { useColumnDefs } from './useTable.utils';
export var useTable = _ref => {
  var {
    data,
    columns,
    meta,
    captionId,
    onRowClick,
    isLoading,
    hideHeaderWhileLoading,
    loadingRowIds,
    disableAllRowsSelection,
    disableRowSelection,
    rowSelectionTooltips,
    defaultSelectedRows = {},
    mobileRowRenderer,
    isHeaderSticky,
    selectedRows: controlledSelectedRows,
    setSelectedRows: setControlledSelectedRows,
    onRowSelectionChange,
    onAllRowsSelectionChange,
    getRowSelectionAriaLabel,
    allRowsSelectionAriaLabel,
    defaultExpandedRows = {},
    onRowExpandChange,
    highlightedRowIds,
    headerVariant = 'light',
    sortingState,
    setSortState,
    getRowAriaLabel,
    skipToLink
  } = _ref,
      otherOptions = _objectWithoutProperties(_ref, _excluded);

  var [uncontrolledSelectedRows, setUncontrolledSelectedRows] = React.useState(defaultSelectedRows);
  var selectedRows = controlledSelectedRows !== null && controlledSelectedRows !== void 0 ? controlledSelectedRows : uncontrolledSelectedRows;
  var setSelectedRows = setControlledSelectedRows !== null && setControlledSelectedRows !== void 0 ? setControlledSelectedRows : setUncontrolledSelectedRows;
  var [expanded, setExpanded] = React.useState(defaultExpandedRows);
  var columnDefs = useColumnDefs({
    columns,
    data,
    disableAllRowsSelection,
    rowSelectionTooltips,
    onRowSelectionChange,
    onAllRowsSelectionChange,
    getRowSelectionAriaLabel,
    allRowsSelectionAriaLabel,
    onRowExpandChange,
    skipToLink
  });
  var {
    getHeaderGroups,
    getRowModel,
    getState
  } = useReactTable(_objectSpread(_objectSpread({
    data,
    columns: columnDefs,
    state: {
      expanded,
      rowSelection: selectedRows,
      sorting: toReactTableSortingState(sortingState)
    },
    onSortingChange: toReactTableOnSortingChange(setSortState),
    // Suppress type error by casting to the expected type.
    meta: meta,
    onRowSelectionChange: setSelectedRows,
    onExpandedChange: setExpanded,
    // Suppress type error by casting to the expected type.
    getSubRows: row => row.subRows,
    getExpandedRowModel: getExpandedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getRowId: (originalRow, index, parent) => originalRow.id || "".concat(parent ? "".concat(parent.index, ".").concat(index) : index)
  }, otherOptions), {}, {
    enableRowSelection: row => {
      // Disable all rows if explicitly set.
      if (disableAllRowsSelection) return false; // Enable all rows by default.

      if (!disableRowSelection) return true; // Disable specific rows.

      return !disableRowSelection(row.original);
    }
  }));
  return {
    getHeaderGroups,
    getRowModel,
    onRowClick,
    isLoading,
    hideHeaderWhileLoading,
    loadingRowIds,
    highlightedRowIds,
    headerVariant,
    mobileRowRenderer: mobileRowRenderer ? rowData => mobileRowRenderer(rowData, meta) : undefined,
    isHeaderSticky,
    captionId,
    getRowAriaLabel,
    sortingState: toPennySortingState(getState().sorting)
  };
};
//# sourceMappingURL=useTable.js.map